var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2329 10.8281L19.7626 10.2985L18.1736 8.7094L15.2626 5.79846L13.6736 4.2094L13.1439 4.73909L12.0845 5.79846L2.74701 15.136C2.25951 15.6235 1.90326 16.2281 1.70639 16.8891L0.0470105 22.5328C-0.070177 22.9266 0.0376355 23.3531 0.332948 23.6438C0.62826 23.9344 1.05014 24.0422 1.44389 23.9297L7.08295 22.2703C7.74389 22.0735 8.34857 21.7172 8.83607 21.2297L18.1736 11.8922L19.2329 10.8281ZM7.50014 18.7219L7.07357 19.786C6.88607 19.9313 6.67514 20.0391 6.45014 20.1094L2.78451 21.1875L3.86264 17.5266C3.92826 17.2969 4.04076 17.086 4.18607 16.9031L5.25014 16.4766V17.9766C5.25014 18.3891 5.58764 18.7266 6.00014 18.7266H7.50014V18.7219ZM17.0017 0.876587L16.3267 1.55627L15.2673 2.61565L14.7329 3.14534L16.322 4.7344L19.2329 7.64534L20.822 9.2344L21.3517 8.70471L22.4111 7.64534L23.0908 6.96565C24.2626 5.79377 24.2626 3.89534 23.0908 2.72346L21.2486 0.876587C20.0767 -0.295288 18.1783 -0.295288 17.0064 0.876587H17.0017ZM14.7798 8.75159L8.02982 15.5016C7.7392 15.7922 7.26107 15.7922 6.97045 15.5016C6.67982 15.211 6.67982 14.7328 6.97045 14.4422L13.7204 7.69221C14.0111 7.40159 14.4892 7.40159 14.7798 7.69221C15.0704 7.98284 15.0704 8.46096 14.7798 8.75159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.61da1b81a79c49771288de09a80225d5.svg";
export { ForwardRef as ReactComponent };